import { FC, ReactNode } from "react";
import Stack from "@mui/material/Stack";
import { Divider, Typography } from "@mui/material";

interface BudgetDetailsSectionWrapperProps {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}

export const BudgetDetailsSectionWrapper: FC<
  BudgetDetailsSectionWrapperProps
> = ({ children, title, action }) => {
  return (
    <Stack border={1} borderRadius={2} borderColor="grey.300" bgcolor="white">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        p={1}
        pl={2}
        height={48}
      >
        <Typography variant="body2" fontWeight="medium">
          {title}
        </Typography>

        {action}
      </Stack>
      <Divider />

      {children}
    </Stack>
  );
};
